module.exports = "/../../dist/frontend/images/404-large.jpg?9232aa49cf1658afe5ee1329902fb9d1";